import useAlertStore from "./store";

export default useAlertStore;
